export default __webpack_public_path__ + "static/media/about-background.7a950a2e.webp";